import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'cyan' | 'green' | 'red' | 'glass' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  loading?: boolean;
}

export function Button({
  children,
  className = '',
  variant = 'cyan',
  size = 'md',
  loading = false,
  disabled,
  ...props
}: ButtonProps) {
  const base = 'inline-flex items-center justify-center font-display font-bold uppercase tracking-wider rounded-xl transition-all duration-200 focus:outline-none focus:ring-2 disabled:opacity-50 disabled:cursor-not-allowed';

  const variants = {
    cyan:  'bg-cyberCyan text-slate-950 hover:bg-cyberCyan/90 hover:shadow-cyanGlow focus:ring-cyberCyan/50',
    green: 'bg-cyberGreen text-slate-950 hover:bg-cyberGreen/90 hover:shadow-greenGlow focus:ring-cyberGreen/50',
    red:   'bg-red-500 text-white hover:bg-red-600 focus:ring-red-500/50',
    glass: 'bg-white/[0.04] text-white hover:bg-white/[0.08] border border-white/10 hover:border-white/20 focus:ring-white/20',
    ghost: 'bg-transparent text-slate-400 hover:text-white hover:bg-white/[0.02] focus:ring-white/10',
  };

  const sizes = {
    sm: 'px-4 py-2 text-[10px] gap-1.5',
    md: 'px-5 py-3 text-xs gap-2',
    lg: 'px-6 py-4 text-sm gap-2.5',
  };

  return (
    <button
      className={`${base} ${variants[variant]} ${sizes[size]} ${className}`}
      disabled={disabled || loading}
      {...props}
    >
      {loading && (
        <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin" />
      )}
      {children}
    </button>
  );
}
